export const PURCHASING_MEMBERS_LABEL = "Purchasing Members";
export const NON_PURCHASING_MEMBERS_LABEL = "Non-Purchasing Members";
export const MEMBER_SAVINGS_LABEL = "Member Savings";
export const TICKETS_SOLD_LABEL = "Tickets Sold";
export const REVENUE_LABEL = "Revenue";

const TIMEFRAME_HINTS: Record<string, string> = {
  "7d": "Last 7 days",
  "30d": "Last 30 days",
  "90d": "Last 90 days",
  "12m": "Last 12 months",
};

export const timeframeHint = (timeframe: string) =>
  TIMEFRAME_HINTS[timeframe] || "Selected period";

export const DASHBOARD_ANALYTICS_TIMEFRAME = "30d";
